import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/summerCamp/Index.vue')
const LiveStation = () => import('../activity/summerCamp/LiveStation.vue')
const SummerCampRostrum = () => import('../activity/summerCamp/Rostrum.vue')
const SummerCampRankingBoard = () => import('../activity/summerCamp/RankingBoard.vue')

export const summerCampRoute: RouteConfig = {
  path: '/summer-camp-activity',
  name: 'summer_camp_activity',
  component: Index,
  meta: {
    title: '趣动夏令营',
  },
}

export const summerCampRostrumRoute: RouteConfig = {
  path: '/summer-camp-rostrum',
  name: 'summer_camp_rostrum',
  component: SummerCampRostrum,
  meta: {
    title: '我的奖牌',
  },
}

export const summerCampLiveStationRoute: RouteConfig = {
  path: '/summer-camp-live-station',
  name: 'summer_camp_live_station',
  component: LiveStation,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '直播台',
  },
}

export const summerCampRankingBoardRoute: RouteConfig = {
  path: '/summer-camp-ranking-board',
  name: 'summer_camp_ranking_board',
  component: SummerCampRankingBoard,
  meta: {
    title: '趣动排行榜',
  },
}

export default [summerCampRoute, summerCampRostrumRoute, summerCampLiveStationRoute, summerCampRankingBoardRoute]
